import { render } from "./Imports.vue?vue&type=template&id=1ddc76ad&scoped=true"
import script from "./Imports.vue?vue&type=script&lang=js"
export * from "./Imports.vue?vue&type=script&lang=js"

import "./Imports.vue?vue&type=style&index=0&id=1ddc76ad&scoped=true&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddc76ad"]])

export default __exports__